// extracted by mini-css-extract-plugin
module.exports = {"xvMobileEmbedOverlay":"_2FLc4"};